import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down_1",
  "use": "icon-down_1-usage",
  "viewBox": "0 0 53 53",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 53 53\" id=\"icon-down_1\">\r\n<polygon fill=\"#e8e6f8\" stroke=\"#000000\" stroke-width=\"0\" stroke-miterlimit=\"10\" points=\"-25,30 -25,1 80,1 80,30 30,50 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol